import React, { useEffect, useState } from 'react';
import Alert from '../../../layouts/Alert';
import _ from 'underscore';

import ClientListItem from './ClientListItem';
import Search from '../../../layouts/Search';
import SortIcon from '../../../layouts/SortIcon';
import Pagination from '../../../layouts/Pagination';

const ClientsList = ({ clientsList, clientListLoading }) => {
  const [listSearch, setListSearch] = useState(clientsList);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [icons, setIcons] = useState({
    title: 0,
  });

  const { title } = icons;

  useEffect(() => {
    if (!clientListLoading) {
      setListSearch(clientsList);
    }
  }, [clientListLoading, setListSearch, clientsList]);

  return (
    <div className='card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 admin-list h-100'>
      <Alert />
      <div className='d-flex w-100 align-items-center justify-content-between mb-3'>
        <div className=''>
          {!clientListLoading && listSearch.length / 7 > 1 && (
            <Pagination
              listSearch={listSearch}
              setPage={setPage}
              size={7}
              page={page}
            />
          )}
        </div>
        <div className='d-flex'>
          <Search
            setListSearch={setListSearch}
            filter={(e) => {
              const list = clientsList.filter((item) =>
                item.title.toUpperCase().includes(e.target.value.toUpperCase()),
              );
              return list;
            }}
            setSearch={setSearch}
          />
        </div>
      </div>
      <div className='row m-0 rounded admin-list-header txt-primary p-2 w-100'>
        <div className='admin-list-fields col p-0 text-truncate '>Title</div>
        <div
          className='admin-list-fields col p-0 text-truncate '
          onClick={() => {
            if (title === 0) {
              setListSearch(_.sortBy(listSearch, 'title'));
              setIcons({
                title: 1,
              });
            } else if (title === 1) {
              let l = _.sortBy(listSearch, 'title');
              setListSearch(l.reverse());
              setIcons({
                title: -1,
              });
            } else {
              setListSearch(clientsList);
              setIcons({
                title: 0,
              });
            }
          }}
        >
          Title
          <SortIcon icon={title} />
        </div>

        <div className='admin-list-fields col p-0 text-truncate text-center'>
          Actions
        </div>
      </div>
      <div className='admin-list-body '>
        {clientListLoading ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          listSearch
            .slice(7 * (page - 1), 7 * page)
            .map((client, id) => <ClientListItem client={client} key={id} />)
        )}
      </div>
    </div>
  );
};

export default ClientsList;
